import * as React from 'react';
import {Button, Col, Row} from 'reactstrap';
import Panel from '../../../theme/components/Panel';
import Table from '../../../theme/components/table/Table';
import DownloadIcon from 'mdi-react/DownloadIcon';
import {localNumber} from '../../../utils/number-utils';
import {mirana, util} from '@wize/mirana-proto/mirana-proto';

interface CoberturasTableProps {
    coberturas: mirana.IPlanCobertura[];
    periodo?: string;
    handleDescargar: () => {};
}

class CoberturasTable extends React.PureComponent<CoberturasTableProps> {

    private get resumen() {

        return <Row>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Fecha: {this.props.periodo}</strong>
                </h4>
            </Col>
            <Col md={{size: 1, offset: 8}} lg={{size: 1, offset: 8}}>
                <Button outline={true} className='icon icon--only' onClick={this.props.handleDescargar}
                        disabled={this.props.coberturas.length <= 0}><DownloadIcon/></Button>
            </Col>
        </Row>;
    }

    public resultados = (resultados: util.IKeyValueDay[] | null | undefined) => {
        const content: any[] = [];
        if (resultados) {
            resultados.forEach((res, index) => {
                content.push(<td key={index} style={{textAlign: 'right'}}>{localNumber(Number(res.value))}</td>)
            });
        }
        return content;
    };

    private get filas() {
        const content: any[] = [];
        if (this.props.coberturas) {
            this.props.coberturas.forEach((cobertura, index) => {
                content.push((
                    <tr key={`cob-${index}`} className={`${cobertura.sublineaOrden === 99 ? 'total' : ''}`}>
                        <td>{cobertura.sublinea}</td>
                        {this.resultados(cobertura.resultados)}
                    </tr>));
            });
        }
        return content;
    }

    private get cabecera() {
        const content: any[] = [];
        if (this.props.coberturas && this.props.coberturas.length > 0) {
            const first = this.props.coberturas[0];
            if (first && first.resultados) {
                first.resultados.forEach((res, index) => {
                    content.push(<th key={index} className='rotate'>
                        <div><span>{res.key}</span></div>
                    </th>)
                });
            }
        }
        return content;
    }

    public render() {
        return (
            <Panel xs={12} md={12} divider={true} title='Resultados'>
                {this.resumen}
                {this.props.coberturas.length > 0 ? <Table striped={true} responsive={true}>
                    <thead>
                    <tr>
                        <th>GRAN FAMILIA</th>
                        {this.cabecera}
                    </tr>
                    </thead>
                    <tbody>
                    {this.filas}
                    </tbody>
                </Table> : null}
            </Panel>
        )
    }
}

export default CoberturasTable;



// WEBPACK FOOTER //
// ./src/components/pages/coberturas/coberturas-table.tsx